import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class EventsCarousel {
    constructor(el) {
        if (!this.set(el)) return;

        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' && !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-events-carousel-slider]');
        this.pagination = this.root.querySelector(
            '[data-events-carousel-pagination]'
        );
        this.prev = this.root.querySelector('[data-events-carousel-prev]');
        this.next = this.root.querySelector('[data-events-carousel-next]');

        this.swiper = null;

        return true;
    }

    init() {
        this.initSwiper();
    }

    initSwiper() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            modules: [Pagination, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            navigation: {
                prevEl: this.prev,
                nextEl: this.next,
            },
            pagination: {
                el: this.pagination,
                clickable: true,
                type: 'bullets',
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'active',
            },
        });
    }
}

const initEventsCarousels = () => {
    const sections = document.querySelectorAll('[data-events-carousel]');
    if (sections) sections.forEach(item => new EventsCarousel(item));
};

initEventsCarousels();
